import { GridPaginationModel } from '@mui/x-data-grid-pro';

export const BASE_PAGINATION_MODEL: GridPaginationModel = {
	page: 0,
	pageSize: 20,
};
